// Flag para evitar reaplicar o tema várias vezes e causar "piscar"
let hasForcedThemeColors = false;

// Utilitário para forçar aplicação das cores corretas
export const forceThemeColors = () => {
  if (hasForcedThemeColors) {
    // Evita reflows desnecessários em chamadas repetidas (ex.: StrictMode, remounts)
    console.log('🎨 Cores já foram forçadas anteriormente, ignorando nova chamada.');
    return;
  }
  hasForcedThemeColors = true;

  // Cores corretas Brasil + Portugal
  const primaryColor = '#22c55e'; // Verde Brasil
  const secondaryColor = '#ef4444'; // Vermelho Portugal

  // Função para ajustar cores
  const adjustColor = (color: string, amount: number) => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    const newR = Math.max(0, Math.min(255, r + amount));
    const newG = Math.max(0, Math.min(255, g + amount));
    const newB = Math.max(0, Math.min(255, b + amount));
    
    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  };

  // Remover estilos antigos
  const oldStyle = document.getElementById('custom-appearance-styles');
  if (oldStyle) {
    oldStyle.remove();
  }

  // Aplicar cores corretas diretamente
  const root = document.documentElement;
  root.style.setProperty('--primary-color', primaryColor);
  root.style.setProperty('--secondary-color', secondaryColor);

  // Criar novo elemento de estilo
  const styleElement = document.createElement('style');
  styleElement.id = 'custom-appearance-styles';
  styleElement.textContent = `
    :root {
      --primary-color: ${primaryColor};
      --secondary-color: ${secondaryColor};
      --primary-50: ${adjustColor(primaryColor, 200)};
      --primary-100: ${adjustColor(primaryColor, 150)};
      --primary-200: ${adjustColor(primaryColor, 100)};
      --primary-300: ${adjustColor(primaryColor, 50)};
      --primary-400: ${adjustColor(primaryColor, 20)};
      --primary-500: ${primaryColor};
      --primary-600: ${adjustColor(primaryColor, -20)};
      --primary-700: ${adjustColor(primaryColor, -40)};
      --primary-800: ${adjustColor(primaryColor, -60)};
      --primary-900: ${adjustColor(primaryColor, -80)};
      
      --secondary-50: ${adjustColor(secondaryColor, 200)};
      --secondary-100: ${adjustColor(secondaryColor, 150)};
      --secondary-200: ${adjustColor(secondaryColor, 100)};
      --secondary-300: ${adjustColor(secondaryColor, 50)};
      --secondary-400: ${adjustColor(secondaryColor, 20)};
      --secondary-500: ${secondaryColor};
      --secondary-600: ${adjustColor(secondaryColor, -20)};
      --secondary-700: ${adjustColor(secondaryColor, -40)};
      --secondary-800: ${adjustColor(secondaryColor, -60)};
      --secondary-900: ${adjustColor(secondaryColor, -80)};
    }
    
    /* Cores Primárias - Backgrounds */
    .bg-primary-50 { background-color: var(--primary-50) !important; }
    .bg-primary-100 { background-color: var(--primary-100) !important; }
    .bg-primary-200 { background-color: var(--primary-200) !important; }
    .bg-primary-300 { background-color: var(--primary-300) !important; }
    .bg-primary-400 { background-color: var(--primary-400) !important; }
    .bg-primary-500 { background-color: var(--primary-500) !important; }
    .bg-primary-600 { background-color: var(--primary-600) !important; }
    .bg-primary-700 { background-color: var(--primary-700) !important; }
    .bg-primary-800 { background-color: var(--primary-800) !important; }
    .bg-primary-900 { background-color: var(--primary-900) !important; }
    
    /* Cores Primárias - Textos */
    .text-primary-50 { color: var(--primary-50) !important; }
    .text-primary-100 { color: var(--primary-100) !important; }
    .text-primary-200 { color: var(--primary-200) !important; }
    .text-primary-300 { color: var(--primary-300) !important; }
    .text-primary-400 { color: var(--primary-400) !important; }
    .text-primary-500 { color: var(--primary-500) !important; }
    .text-primary-600 { color: var(--primary-600) !important; }
    .text-primary-700 { color: var(--primary-700) !important; }
    .text-primary-800 { color: var(--primary-800) !important; }
    .text-primary-900 { color: var(--primary-900) !important; }
    
    /* Cores Primárias - Bordas */
    .border-primary-50 { border-color: var(--primary-50) !important; }
    .border-primary-100 { border-color: var(--primary-100) !important; }
    .border-primary-200 { border-color: var(--primary-200) !important; }
    .border-primary-300 { border-color: var(--primary-300) !important; }
    .border-primary-400 { border-color: var(--primary-400) !important; }
    .border-primary-500 { border-color: var(--primary-500) !important; }
    .border-primary-600 { border-color: var(--primary-600) !important; }
    .border-primary-700 { border-color: var(--primary-700) !important; }
    .border-primary-800 { border-color: var(--primary-800) !important; }
    .border-primary-900 { border-color: var(--primary-900) !important; }
    
    /* Cores Secundárias - Backgrounds */
    .bg-secondary-50 { background-color: var(--secondary-50) !important; }
    .bg-secondary-100 { background-color: var(--secondary-100) !important; }
    .bg-secondary-200 { background-color: var(--secondary-200) !important; }
    .bg-secondary-300 { background-color: var(--secondary-300) !important; }
    .bg-secondary-400 { background-color: var(--secondary-400) !important; }
    .bg-secondary-500 { background-color: var(--secondary-500) !important; }
    .bg-secondary-600 { background-color: var(--secondary-600) !important; }
    .bg-secondary-700 { background-color: var(--secondary-700) !important; }
    .bg-secondary-800 { background-color: var(--secondary-800) !important; }
    .bg-secondary-900 { background-color: var(--secondary-900) !important; }
    
    /* Cores Secundárias - Textos */
    .text-secondary-50 { color: var(--secondary-50) !important; }
    .text-secondary-100 { color: var(--secondary-100) !important; }
    .text-secondary-200 { color: var(--secondary-200) !important; }
    .text-secondary-300 { color: var(--secondary-300) !important; }
    .text-secondary-400 { color: var(--secondary-400) !important; }
    .text-secondary-500 { color: var(--secondary-500) !important; }
    .text-secondary-600 { color: var(--secondary-600) !important; }
    .text-secondary-700 { color: var(--secondary-700) !important; }
    .text-secondary-800 { color: var(--secondary-800) !important; }
    .text-secondary-900 { color: var(--secondary-900) !important; }
    
    /* Cores Secundárias - Bordas */
    .border-secondary-50 { border-color: var(--secondary-50) !important; }
    .border-secondary-100 { border-color: var(--secondary-100) !important; }
    .border-secondary-200 { border-color: var(--secondary-200) !important; }
    .border-secondary-300 { border-color: var(--secondary-300) !important; }
    .border-secondary-400 { border-color: var(--secondary-400) !important; }
    .border-secondary-500 { border-color: var(--secondary-500) !important; }
    .border-secondary-600 { border-color: var(--secondary-600) !important; }
    .border-secondary-700 { border-color: var(--secondary-700) !important; }
    .border-secondary-800 { border-color: var(--secondary-800) !important; }
    .border-secondary-900 { border-color: var(--secondary-900) !important; }
    
    /* Hover States */
    .hover\\:bg-primary-50:hover { background-color: var(--primary-50) !important; }
    .hover\\:bg-primary-100:hover { background-color: var(--primary-100) !important; }
    .hover\\:bg-primary-200:hover { background-color: var(--primary-200) !important; }
    .hover\\:bg-primary-300:hover { background-color: var(--primary-300) !important; }
    .hover\\:bg-primary-400:hover { background-color: var(--primary-400) !important; }
    .hover\\:bg-primary-500:hover { background-color: var(--primary-500) !important; }
    .hover\\:bg-primary-600:hover { background-color: var(--primary-600) !important; }
    .hover\\:bg-primary-700:hover { background-color: var(--primary-700) !important; }
    .hover\\:bg-primary-800:hover { background-color: var(--primary-800) !important; }
    .hover\\:bg-primary-900:hover { background-color: var(--primary-900) !important; }
    
    .hover\\:text-primary-50:hover { color: var(--primary-50) !important; }
    .hover\\:text-primary-100:hover { color: var(--primary-100) !important; }
    .hover\\:text-primary-200:hover { color: var(--primary-200) !important; }
    .hover\\:text-primary-300:hover { color: var(--primary-300) !important; }
    .hover\\:text-primary-400:hover { color: var(--primary-400) !important; }
    .hover\\:text-primary-500:hover { color: var(--primary-500) !important; }
    .hover\\:text-primary-600:hover { color: var(--primary-600) !important; }
    .hover\\:text-primary-700:hover { color: var(--primary-700) !important; }
    .hover\\:text-primary-800:hover { color: var(--primary-800) !important; }
    .hover\\:text-primary-900:hover { color: var(--primary-900) !important; }
    
    /* Focus States */
    .focus\\:ring-primary-500:focus { --tw-ring-color: var(--primary-500) !important; }
    .focus\\:ring-primary-600:focus { --tw-ring-color: var(--primary-600) !important; }
    .focus\\:border-primary-500:focus { border-color: var(--primary-500) !important; }
    .focus\\:border-primary-600:focus { border-color: var(--primary-600) !important; }
    
    /* Gradientes para textos */
    .bg-gradient-to-r.from-primary-500.to-secondary-500 { 
      background: linear-gradient(to right, var(--primary-500), var(--secondary-500)) !important; 
    }
    .bg-gradient-to-r.from-primary-600.to-secondary-600 { 
      background: linear-gradient(to right, var(--primary-600), var(--secondary-600)) !important; 
    }
    
    /* Gradientes para backgrounds */
    .bg-gradient-to-br.from-primary-50.via-white.to-secondary-50 {
      background: linear-gradient(to bottom right, var(--primary-50), white, var(--secondary-50)) !important;
    }
    
    /* Gradientes para textos com clip */
    .text-transparent.bg-clip-text.bg-gradient-to-r.from-primary-600.to-secondary-600 {
      background: linear-gradient(to right, var(--primary-600), var(--secondary-600)) !important;
      -webkit-background-clip: text !important;
      background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      color: transparent !important;
    }
    
    /* Gradientes para textos com clip - variações */
    .text-transparent.bg-clip-text.bg-gradient-to-r.from-primary-500.to-secondary-500 {
      background: linear-gradient(to right, var(--primary-500), var(--secondary-500)) !important;
      -webkit-background-clip: text !important;
      background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      color: transparent !important;
    }
    
    /* Animações removidas para evitar efeitos indesejados */
    
    /* Botões dinâmicos */
    .btn-primary {
      background-color: var(--primary-600) !important;
      color: white !important;
      border-color: var(--primary-600) !important;
    }
    .btn-primary:hover {
      background-color: var(--primary-700) !important;
      border-color: var(--primary-700) !important;
    }
    
    .btn-secondary {
      background-color: var(--secondary-600) !important;
      color: white !important;
      border-color: var(--secondary-600) !important;
    }
    .btn-secondary:hover {
      background-color: var(--secondary-700) !important;
      border-color: var(--secondary-700) !important;
    }
    
    .btn-outline {
      background-color: transparent !important;
      color: var(--primary-600) !important;
      border-color: var(--primary-600) !important;
    }
    .btn-outline:hover {
      background-color: var(--primary-600) !important;
      color: white !important;
    }
    
  `;

  document.head.appendChild(styleElement);
};
